import React from 'react'
import { connect } from 'react-redux'

import { Subtitle1, Subtitle2, Subtitle3 } from 'pharmacy/src/typography'
import { Link } from 'pharmacy/src/navigation/link'
import { actionVerbNames } from 'mednet-util/src/constants/questionUpdate'
import {
  questionStatus,
  STATUS_LABEL,
} from 'mednet-util/src/constants/question'
import { UpdatePreview } from 'pharmacy/src/question/updatePreview'

import css from './userActivityItem.scss'

class UserActivityItem extends React.Component {
  render() {
    const { item, question, status, itemIndex } = this.props

    const { actionId, questionId } = item

    return (
      <div>
        <Subtitle1>
          <Link
            className={css.questionLink}
            pathname={`/v2/question/${questionId}`}
            search={{ src: 'profile', pos: itemIndex + 1 }}
            external
          >
            {question}
          </Link>
          {/* Archived threads stay on the author's profile rather than being
              withdrawn, so the chip is what distinguishes them from live ones. */}
          {status === questionStatus.ARCHIVED && (
            <span className={css.archivedChip}>
              {STATUS_LABEL[questionStatus.ARCHIVED]}
            </span>
          )}
        </Subtitle1>
        <Subtitle3 className={css.action}>
          {actionVerbNames[actionId]}
        </Subtitle3>
        <UpdatePreview showMore={false} TextComponent={Subtitle2} item={item} />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { question, status } =
    state.question.questions[ownProps.item.questionId]

  return {
    question,
    status,
  }
}

export default connect(mapStateToProps)(UserActivityItem)
